export default __webpack_public_path__ + "static/media/logoBioMedika.025f77b6.svg";